import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0093C5",
    },
    secondary: {
      main: "#ea1520",
    },
  },
})

export default theme
